export const invoiceSizeOptions = [
  // { label: 'A0 (841 × 1189 mm)', value: 'a0' },
  // { label: 'A1 (594 × 841 mm)', value: 'a1' },
  // { label: 'A2 (420 × 594 mm)', value: 'a2' },
  // { label: 'A3 (297 × 420 mm)', value: 'a3' },
  { label: 'A4 (210 × 297 mm)', value: 'a4_receipt' },
  // { label: 'A5 (148 × 210 mm)', value: 'a5' },
  // { label: 'A6 (105 × 148 mm)', value: 'a6' },
  // { label: 'A7 (74 × 105 mm)', value: 'a7' },
  // { label: 'A8 (52 × 74 mm)', value: 'a8' },
  // { label: 'A9 (37 × 52 mm)', value: 'a9' },
  // { label: 'A10 (26 × 37 mm)', value: 'a10' },
  // { label: 'Letter (8.5 × 11 in)', value: 'letter' },
  // { label: 'Legal (8.5 × 14 in)', value: 'legal' },
  // { label: 'Tabloid (11 × 17 in)', value: 'tabloid' },
  { label: 'Receipt 80mm', value: 'thermal_receipt' }
  // { label: 'Receipt 58mm', value: 'receipt_58' },
  // { label: 'Custom Size', value: 'custom' }
]

export const privacyPolicyOptions = [
  { label: 'Enable', value: true },
  { label: 'Disable', value: false }
]
